import { render, staticRenderFns } from "./VaimoBanner.vue?vue&type=template&id=2767e7aa&scoped=true&"
import script from "./VaimoBanner.vue?vue&type=script&lang=js&"
export * from "./VaimoBanner.vue?vue&type=script&lang=js&"
import style0 from "./VaimoBanner.vue?vue&type=style&index=0&id=2767e7aa&prod&lang=scss&scoped=true&"
import style1 from "./VaimoBanner.vue?vue&type=style&index=1&id=2767e7aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2767e7aa",
  null
  
)

export default component.exports